function cleancsvvalue(value) {
	return value
		.replace(/^\s*|\s*$/g, "") // remove leading & trailing space
		.replace(/^"|"$/g, "") // remove " on the beginning and end
		.replace(/""/g, '"'); // replace "" with "
}

function csvtojson(text) {
	let $ctrl = this;
	var content = {
		csv: text.replace(/\r\n|\r/g, "\n"),
		header: true,
		separator: ","
	};
	$ctrl.content = content.csv;
	var lines = content.csv.split(
		new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')
	);
	var result = [];
	var start = 0;
	var columncount = lines[0].split(content.separator).length;

	var headers = [];
	if (content.header) {
		headers = lines[0].split(content.separator);
		start = 1;
	}
	for (var i = start; i < lines.length; i++) {
		var obj = {};
		var currentline = lines[i].split(
			new RegExp(content.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')
		);
		if (currentline.length === columncount) {
			if (content.header) {
				for (var j = 0; j < headers.length; j++) {
					obj[headers[j]] = cleancsvvalue(currentline[j]);
				}
			} else {
				for (var k = 0; k < currentline.length; k++) {
					obj[k] = cleancsvvalue(currentline[k]);
				}
			}
			result.push(obj);
		}
	}
	return result;
}
const csvJson = {
	parse: csvtojson
};

export default csvJson;
